import React from "react";

import useAuth from "../../utils/useAuth";
import StudentPage from "./student";
import CoachPage from "./coach";

const Nutrition = () => {
  let { isStudent, isStaff } = useAuth();

  if (isStudent) return <StudentPage />;
  else if (isStaff) return <CoachPage />;
};

export default Nutrition;
